import { type AppliedColumnPreset, type ColumnPreset } from '../types';

/**
 * A preset needs (re-)applying when the persisted settings have not seen it
 * yet, either because a different preset (or none) was applied before, or
 * because its version was bumped. Afterwards the user's own settings win.
 */
export function getShouldApplyColumnPreset(
  userSettings: Record<string, unknown>,
  columnPreset: ColumnPreset | undefined,
): boolean {
  if (columnPreset === undefined) {
    return false;
  }

  const appliedColumnPreset = userSettings.appliedColumnPreset as
    | Partial<AppliedColumnPreset>
    | undefined;

  // The marker comes from persisted settings that nothing validates, so treat
  // anything that is not a well-formed marker for this preset as "not applied
  // yet". A corrupted value then costs one extra application, which writes a
  // sound marker, instead of disabling the preset for that user forever.
  if (
    appliedColumnPreset?.id !== columnPreset.id ||
    typeof appliedColumnPreset.version !== 'number'
  ) {
    return true;
  }

  return appliedColumnPreset.version < columnPreset.version;
}
